import { createApp } from 'vue'
import { Directus } from '@directus/sdk'
import smoothscroll from 'smoothscroll-polyfill'
import VueSvgInlinePlugin from 'vue-svg-inline-plugin'
import App from './App.vue'
import router from './router'
import 'windi.css'

smoothscroll.polyfill()
require('cleave.js/dist/addons/cleave-phone.ru')

// eslint-disable-next-line
export const backend = (async () => {
  try {
    const backendUrl = await process.env.VUE_APP_BACKEND_URL
    const directus = new Directus(backendUrl)
    console.log(`Successfully connected to backend: ${backendUrl}`)
    return directus
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('Failed to find backend url: ', error)
  }
  return undefined
})()

createApp(App).use(router).use(VueSvgInlinePlugin).mount('#app')
